import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const Highlighter = styled.div.withConfig({
  displayName: "scroll__Highlighter",
  componentId: "sc-1ykdvg1-0"
})(({
  isSection
}) => {
  const cssStyles = useMapTokenPropsToCSS(Object.assign({
    inlineSize: isSection ? '100%' : 'calc(100% - 44px)',
    blockSize: '100%',
    boxShadow: '100',
    borderWidth: '200',
    borderStyle: 'solid',
    borderColor: 'fill-accent-blue-default',
    paddingInline: '200',
    paddingBlock: '300'
  }, isSection ? {
    margin: '0'
  } : {
    marginInlineStart: '200'
  }));
  return Object.assign({
    left: isSection ? -12 : 0,
    top: isSection ? -6 : 0,
    position: 'absolute',
    boxSizing: 'content-box',
    borderRadius: 12,
    '~ *': {
      position: 'relative'
    }
  }, cssStyles);
});
// Try to get section element, and if that fails try again after a second
// in case the element hasn't loaded yet
async function getSectionEl(fieldEl, section) {
  const getSection = () => fieldEl.querySelector(`[data-field-section="${section}"]`);
  const sectionEl = getSection();
  if (!sectionEl) {
    const promise = new Promise(resolve => setTimeout(() => {
      resolve(getSection());
    }, 1000));
    return await promise;
  }
  return sectionEl;
}
export async function scrollFieldIntoView(fieldKey, section) {
  const fieldEl = document.querySelector(`[data-field-key="${fieldKey.join('.')}"]`);
  if (fieldEl) {
    const sectionEl = section && (await getSectionEl(fieldEl, section));
    if (sectionEl) {
      scrollToAndHighlightElement(sectionEl, true);
    } else {
      scrollToAndHighlightElement(fieldEl);
    }
  }
}
export function scrollToAndHighlightElement(element, isSection = false) {
  element.scrollIntoViewIfNeeded();
  let highlighter = document.createElement('div');
  const highlighterHTML = renderToStaticMarkup( /*#__PURE__*/_jsx(Highlighter, {
    isSection: isSection
  }));
  highlighter.innerHTML = highlighterHTML;
  highlighter = highlighter.firstElementChild;
  element.prepend(highlighter);
  element.style.position = 'relative';
  setTimeout(() => {
    highlighter.remove();
    element.style.position = '';
  }, 3000);
}